import { useTranslation } from "react-i18next";

function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col h-screen items-center justify-center gap-2">
      <div className="text-2xl">{t("not-found.title")}</div>
      <div>
        <span>{t("not-found.message-1")}</span>
        <span>{t("not-found.message-2")}</span>
        <a href="/console/all-assessments" className="text-blue-500 underline">
          {t("not-found.submission-page")}
        </a>
        {t("not-found.message-3")}
      </div>
    </div>
  );
}

export default NotFound;
